import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import IconButton from '@mui/material/IconButton';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import config from 'config/config';

// React port of the old public/liveChatEntry.js widget (bottom-right button,
// 400x680 iframe to the same Ropla live-chat backend), driven by
// REACT_APP_CHAT_WIDGET_URL instead of a hardcoded URL baked into a static
// public/ script. Always available regardless of cookie consent - this is
// in-house company infrastructure, not third-party tracking.
const ChatWidgetButton = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  if (!config.CHAT_WIDGET_URL) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: theme.spacing(3.75),
        right: theme.spacing(2),
        zIndex: theme.zIndex.snackbar,
      }}
    >
      {open ? (
        <Box
          sx={{
            width: 400,
            height: 680,
            maxWidth: '90vw',
            maxHeight: '80vh',
            boxShadow: theme.shadows[8],
            borderRadius: 1.5,
            overflow: 'hidden',
            backgroundColor: '#F5F7FA',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              backgroundColor: theme.palette.primary.main,
            }}
          >
            <IconButton
              aria-label="Close chat"
              onClick={() => setOpen(false)}
              size="small"
              sx={{ color: theme.palette.primary.contrastText }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <Box
            component="iframe"
            title="Live chat"
            src={config.CHAT_WIDGET_URL}
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-downloads"
            allow="camera; microphone; autoplay; speaker; speaker-selection"
            sx={{ flex: 1, border: 0 }}
          />
        </Box>
      ) : (
        <Fab
          color="primary"
          aria-label="Open chat"
          onClick={() => setOpen(true)}
        >
          <ChatBubbleOutlineIcon />
        </Fab>
      )}
    </Box>
  );
};

export default ChatWidgetButton;
